// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","455":"4a0eb397","977":"aae465e0"}[chunkId] + ".chunk.js";
};